import React, { Component } from 'react';
import { Panel } from 'primereact/panel';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { PropTypes } from 'prop-types';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { defineMessages, injectIntl } from 'react-intl';
import { withAccount } from '../../components/AccountContext';
import { Loading } from '../../components/Loading';
import apollo from '../../services/apollo';
import { withGrowl } from '../../components/GrowlNotifications';
import { growlErrors, growlActionSuccess } from '../../utils/NotificationUtil';
import { intlShape } from '../../components/prop-types';


const messages = defineMessages({
  hierarchicalBelow: {
    id: 'settings.hierarchicalBelow',
    defaultMessage: 'This account is hierarchical below',
  },
  moveUnder: {
    id: 'settings.moveUnder',
    defaultMessage: 'Move under',
  },
  noData: {
    id: 'settings.notification.canNotPerform',
    defaultMessage: 'This operation can\'t be performed on this account.',
  },
  update: {
    id: 'actions.update',
    defaultMessage: 'Update',
  },
});

const AVAILABLE_PARENTS = gql`
query getAvailableParents($accountId: ID!){
  account(id: $accountId) {
    id
    availableParents {
      ancestorId,
      ancestorBrandDisplayName
    }
  }
}
`;

const UPDATE_PARENT = gql`
mutation ($input: UpdateParentInput!) {
  updateParent(input: $input) {
    account {
      id
    }
  }
}
`;

class OrganizationallyBelowPanel extends Component {
  state = { newParent: null }

  handleChangeParent = async () => {
    const { newParent } = this.state;
    const { currentAccount, growl } = this.props;

    await apollo.mutate({
      mutation: UPDATE_PARENT,
      variables: {
        input: {
          accountId: currentAccount,
          newParentId: newParent.ancestorId,
        },
      },
    })
      .then(res => res.data)
      .catch((err) => {
        growlErrors(growl, err);
      });

    this.setState({ newParent: null });
    growlActionSuccess(growl, 'Account update.');
  }

  render() {
    const { currentAccount, intl: { formatMessage } } = this.props;

    return (
      <div className="p-grid p-nogutter">
        <div className="p-col">

          <Panel header={formatMessage(messages.hierarchicalBelow)}>
            <Query query={AVAILABLE_PARENTS} variables={{ accountId: currentAccount }} partialRefetch>
              {({ data, loading, error }) => {
                if (error) {
                  return `Error ${error.message}`;
                }

                if (loading) {
                  return <Loading />;
                }

                if (data.account.availableParents.length === 0) {
                  return (
                    <div>
                      {formatMessage(messages.noData)}
                    </div>
                  );
                }

                const { newParent } = this.state;
                return (
                  <>
                    <Dropdown
                      value={newParent}
                      optionLabel="ancestorBrandDisplayName"
                      placeholder={formatMessage(messages.moveUnder)}
                      options={data.account.availableParents}
                      onChange={(e) => {
                        this.setState({ newParent: e.target.value });
                      }}
                    />
                    <Button
                      label="Update"
                      disabled={!newParent}
                      className="pull-right"
                      onClick={this.handleChangeParent}
                    />
                  </>
                );
              }}
            </Query>
          </Panel>
        </div>
      </div>
    );
  }
}

OrganizationallyBelowPanel.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  growl: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(withAccount(withGrowl(OrganizationallyBelowPanel)));
